export const biotechnologyData = {
  departmentName: "Department of Biotechnology",
  bannerImage: "/infrastructure/biotechnology/banner.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Biotechnology at Rayalaseema University is dedicated to advancing knowledge in the 
    interdisciplinary field of biotechnology. Our programs integrate biology, chemistry, and engineering principles 
    to develop innovative solutions for healthcare, agriculture, and environmental sustainability. We focus on 
    genetic engineering, microbiology, bioinformatics, and bioprocess technology, preparing students for careers 
    in research, pharmaceuticals, and biotechnology industries.`,
    highlights: [
      "Advanced molecular biology and genetic engineering laboratories",
      "Research facilities for microbiology and cell culture",
      "Bioinformatics and computational biology resources",
      "Collaborations with pharmaceutical and biotechnology companies"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/biotechnology/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    id: "bio002",
      name: "Dr. K. Monika",
      designation: "Co-ordinator,Assistant Professor(C)",
      email: "monikasku.7@gmail.com",
      mobile: "+91 9440363555",
      photo: "/biotechnology/mounika.JPG",
      qualification: "M.Sc., Ph.D.",
      specialization: "Microbiology and Bioinformatics",
      profileLink: "/biotechnology/mounika.pdf",
    // id:'bot001',
    // name: "Dr. Bharath Kumar Ravuru",
    // designation: "Professor & Head",
    // photo: "/botany/bharath.JPG",
    // email: "drbharathravuru@gmail.com",
    // mobile: "8500722075",
    // qualification: "M.Sc., Ph.D.",
    // specialization: "Plant Biotechnology, Ethnobotany &  Forest Ecology ",
    // profileLink: "/botany/bharath.pdf",
    message: `Welcome to the Department of Biotechnology. We are committed to excellence in biotechnology education 
    and research. Our department provides a stimulating environment for students to explore the fascinating world 
    of biological sciences and their applications in solving global challenges.`,
   },

  bos: {
  title: "Biotechnology",
  members: [
    {
      name: "Prof. V. Lokanatha",
      designation: "Chairperson",
      affiliation: "Dept. of Zoology, Dravidian University, Kuppam"
    },
    {
      name: "Prof. J. S. S. Prakash",
      designation: "Member",
      affiliation: "University of Hyderabad, Hyderabad"
    },
    {
      name: "Prof. Kalarani",
      designation: "Member",
      affiliation: "Sri Padmavathi Mahila University, Tirupati"
    },
    {
      name: "Prof. Hemalatha",
      designation: "Member",
      affiliation: "Andhra University, Visakhapatnam"
    },
    {
      name: "Prof. Kavi Kishore",
      designation: "Member",
      affiliation: "CEO, Genemics Corp, Pulivendula, Kadapa"
    },
    {
      name: "Prof. P. S. Shavali Khan",
      designation: "Member",
      affiliation: "Dept. of Botany, Yogi Vemana University, Kadapa"
    }
  ]
}
,

  faculty: [
    {
      id: "bio001",
      name: "Dr.G.V.Swarnalatha",
      designation: "Assistant Professor(C)",
      email: "venkata85722@gmail.com",
      mobile: "+91 8639514999",
      photo: "/biotechnology/Dr.Swarnalatha.JPG",
      qualification: "M.Sc., Ph.D.,CSIR-NET",
      specialization: "Algal Biochemistry",
      profileLink: "/biotechnology/Dr.Swarnalatha.pdf"
    },
     {
      id: "bio002",
      name: "Dr. K. Monika",
      designation: "Co-ordinator,Assistant Professor(C)",
      email: "monikasku.7@gmail.com",
      mobile: "+91 9440363555",
      photo: "/biotechnology/mounika.JPG",
      qualification: "M.Sc., Ph.D.",
      specialization: "Microbiology and Bioinformatics",
      profileLink: "/biotechnology/mounika.pdf"
    },
    
   
  ],

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.Tech Biotechnology",
    //     duration: "4 Years",
    //     eligibility: "10+2 with Physics, Chemistry, and Biology/Mathematics",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.Sc. Biotechnology",
        duration: "2 Years",
        eligibility: "B.Sc. with Biology/Biotechnology",
        intake: "30 seats"
      },
      // {
      //   name: "M.Tech Biotechnology",
      //   duration: "2 Years",
      //   eligibility: "B.E./B.Tech/M.Sc. in relevant field",
      //   intake: "20 seats"
      // }
    ],
    // research: [
    //   {
    //     name: "Ph.D. in Biotechnology",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Sc./M.Tech with qualifying exam",
    //     areas: "Genetic Engineering, Microbiology, Bioinformatics, Bioprocess Technology, Plant Biotechnology"
    //   }
    // ]
  },

  Infrastructure: [
  // "/infrastructure/biotechnology/class-1.JPG",
  "/infrastructure/biotechnology/class-2.JPG",
  "/infrastructure/biotechnology/class-3.JPG",
  "/infrastructure/biotechnology/lab-1.JPG",
  "/infrastructure/biotechnology/lab-2.JPG",
  "/infrastructure/biotechnology/lab-3.JPG",
  "/infrastructure/biotechnology/lab-4.JPG"
]
};
